import React from 'react';
import './TableDocumentIssuance.scss';
import {AddRowIcon, DeleteIcon} from "../SvgExport/SvgExport";
import UtilsFunctions from "../../../../../utils/UtilsFunctions";
import DynaSelectBox from "../../../DynaView/DynaSelectBox";

const TableDocumentIssuance = ({initialData, sendData, setSendData}) => {

  const deleteRowHandler = (item) => {
    const filtered = sendData?.documentDetails.filter(detail => detail.uniqId !== item.uniqId)
    setSendData({...sendData, documentDetails: filtered})
  }

  const addRowHandler = () => {
    let temp = [...sendData?.documentDetails]
    temp.push({
      uniqId: Math.random() * 13,
      accountCode_3: "",
      accountCode_4: "",
      description: "",
      hasSubAccount: false,
      bed: "0",
      bes: "0"
    })
    setSendData({...sendData, documentDetails: temp})
  }

  const accountCode3Handler = async (data, item) => {
    let temp = [...sendData?.documentDetails]
    temp.forEach((row) => {
      if (item?.uniqId === row.uniqId) {
        row.hasSubAccount = data?.hasSubAccount
        row.accountCodes = data?.accountCodes
        row.accountCode_3 = data?.value
        row.accountCode_4 = ""
        row.description = data?.hasSubAccount ? "" : data?.description
      }
    })
    setSendData({...sendData, documentDetails: temp})
  }

  const accountCode4Handler = async (data, item) => {

    let temp = [...sendData?.documentDetails]

    temp.forEach((row) => {
      if (item?.uniqId === row.uniqId) {
        row.accountCode_4 = data?.value
        row.description = data?.description
      }
    })
    setSendData({...sendData, documentDetails: temp})
  }

  const inputChangeHandler = (value, item, name) => {
    if (!isNaN(UtilsFunctions.removeCommas(value)) && !value.includes(" ")) {
      let temp = [...sendData?.documentDetails]
      temp.forEach((row) => {
        if (item?.uniqId === row.uniqId) {
          if (name === "bed") {
            row.bed = +UtilsFunctions.removeCommas(value) > 0 ? UtilsFunctions.removeCommas(value) : 0
            row.bes = 0
          } else {
            row.bed = 0
            row.bes = +UtilsFunctions.removeCommas(value) > 0 ? UtilsFunctions.removeCommas(value) : 0
          }
        }
      })
      setSendData({...sendData, documentDetails: temp})
    }
  }

  const descriptionChangeHandel = (value, item) => {
    if (value !== " ") {
      let temp = [...sendData?.documentDetails]

      temp.forEach((row) => {
        if (item?.uniqId === row.uniqId) {
          row.description = value
        }
      })
      setSendData({...sendData, documentDetails: temp})
    }
  }

  const handleKeyDownTab = (event, data, name) => {

    const lastIndex = sendData?.documentDetails.length - 1;
    let temp = [...sendData?.documentDetails]
    if (event.key === 'Tab' && sendData?.documentDetails[lastIndex].uniqId === data.uniqId && name === "bes") {
      temp.push({
        uniqId: Math.random() * 13,
        accountCode_3: "",
        accountCode_4: "",
        description: "",
        hasSubAccount: false,
        bed: "0",
        bes: "0"
      })
      setSendData({...sendData, documentDetails: temp})
    }
    if (event.key === '+') {
      event.preventDefault();
      temp.forEach((row) => {
        if (data?.uniqId === row.uniqId) {
          if (name === "bed") {
            row.bed = row.bed.toString() + '000'
          } else {
            row.bes = row.bes.toString() + '000'
          }
        }
      })
      setSendData({...sendData, documentDetails: temp})
    }

    if (event.key === '-') {
      event.preventDefault();
      temp.forEach((row) => {
        if (data?.uniqId === row.uniqId) {
          if (name === "bed") {
            row.bed = Math.floor(row.bed / 1000)
          } else {
            row.bes = Math.floor(row.bes / 1000)
          }
        }
      })
      setSendData({...sendData, documentDetails: temp})
    }

    if (event.key === ' ') {
      event.preventDefault();
      let bed = 0
      let bes = 0
      sendData?.documentDetails.forEach((item) => {
        bed = bed + +item?.bed
        bes = bes + +item?.bes
      })
      const total = bed - bes;
      temp.forEach((row) => {
        if (data?.uniqId === row.uniqId) {
          if (name === "bed") {
            row.bed = total < 0 ? (total * -1) : total
            row.bes = 0
          } else {
            row.bes = total < 0 ? (total * -1) : total
            row.bed = 0
          }
        }
      })
      setSendData({...sendData, documentDetails: temp})
    }
  };

  try {
    return (
      <ul className="TableDocumentIssuance">

        <li className={"header-side"}>
          <h6 style={{width: "6%", borderTopRightRadius: "10px"}}>عملیات</h6>
          <h6 style={{width: "6%"}}>ردیف</h6>
          <h6 style={{width: "20%"}}>عنوان حساب</h6>
          <h6 style={{width: "20%"}}>تفصیلی</h6>
          <h6 style={{width: "20%"}}>توضیحات</h6>
          <h6 style={{width: "14%"}}>بدهکار</h6>
          <h6 style={{width: "14%", borderTopLeftRadius: "10px"}}>بستانکار</h6>
        </li>

        {sendData?.documentDetails.length > 0 && sendData?.documentDetails.map((item, index) =>
          <li key={"rw" + index} className={"body-side"}>
            <h6 style={{width: "6%"}} onClick={() => deleteRowHandler(item)}><DeleteIcon/></h6>
            <h6 style={{width: "6%"}}>{index + 1}</h6>
            <div style={{width: "20%"}}>
              <DynaSelectBox options={initialData?.pageData?.accounts}
                             hasFilter={true}
                             label={""}
                             activeFocus={true}
                             className={"solid-dyna-input"}
                             value={item?.accountCode_3}
                             onChange={(data) => accountCode3Handler(data, item)}
              />
            </div>
            <div style={{width: "20%"}}>
              {item?.hasSubAccount ?
                <DynaSelectBox options={item?.accountCodes}
                               hasFilter={true}
                               label={""}
                               activeFocus={true}
                               className={"solid-dyna-input"}
                               value={item?.accountCode_4}
                               onChange={(data) => accountCode4Handler(data, item)}
                /> : <h6>----</h6>}
            </div>
            <div style={{width: "20%", color: "#3F74FF"}}>
              <input value={item?.description} className={"input-table"}
                     onChange={(e) => descriptionChangeHandel(e.target.value, item)}/>
            </div>
            <div style={{width: "14%"}}>
              <input value={UtilsFunctions.addCommas(item?.bed)} className={"input-table"}
                     onKeyDown={(e) => handleKeyDownTab(e, item, "bed")}
                     onChange={(e) => inputChangeHandler(e.target.value, item, "bed")}/>
            </div>
            <div style={{width: "14%"}}>
              <input value={UtilsFunctions.addCommas(item?.bes)} className={"input-table"}
                     onKeyDown={(e) => handleKeyDownTab(e, item, "bes")}
                     onChange={(e) => inputChangeHandler(e.target.value, item, "bes")}/>
            </div>
          </li>
        )}

        <li className={"add-row"}>
          <button onClick={addRowHandler}>
            <AddRowIcon/>
            افزودن ردیف
          </button>
        </li>
      </ul>
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default TableDocumentIssuance;